import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, FormGroup, MenuItem, Select, TextareaAutosize } from '@mui/material';
import { Alert, Box, Chip, IconButton, Snackbar, Stack, TablePagination, TextField} from '@mui/material';
import React, { useEffect, useState } from 'react';
import ApiServices from '../services/ApiServices';
import Popup from './Popup';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import moment from 'moment';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import DeviceLog from '../pages/DeviceLog';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { ClearAll, ContentCopy, Close, Delete, Search } from '@mui/icons-material';
import { DataGrid } from '@mui/x-data-grid';
function AutomationTable(props) {

    const columns = [
        {
            field: 'checkbox', flex: 0.3, sortable: false,
            renderHeader: (params) => {
                const calledClick = (e) => {
                    const allImeiNoOta = devices.filter(device => !device.ota_status).map(i => i.deviceIMEI);
                    if (e.target.checked) setSelectedDevice((oldList) => [...oldList, ...allImeiNoOta])
                    else setSelectedDevice((item) => item.filter((item) => !allImeiNoOta.includes(item)));
                }
                const selectedAll = () => {
                    if (devices.length > 0) return devices.filter(device => !device.ota_status).every(item => selectedDevice.includes(item.deviceIMEI));
                    else return false;
                }
                return <Checkbox style={{ padding: 4 }} checked={selectedAll()} onClick={calledClick} />;
            },
            renderCell: (params) => {
                const stopExtra = (e) => {
                    if (e.target.checked) setSelectedDevice(oldLIst => [...oldLIst, params.id])
                    else setSelectedDevice((item) => item.filter((item) => item !== params.id));
                }
                const asj = () => {
                    if (params.row.ota_status) return false;
                    else return selectedDevice.includes(params.id);
                }
                const diasbleCell = () => {
                    if (params.row.ota_status) return true;
                    else return false;
                }
                return <Checkbox disabled={diasbleCell()} checked={asj()} onClick={stopExtra} />;
            }
        },
        { field: 'organisationName', headerName: 'Organisation', flex: 0.9, sortable: false, renderCell: (params) => renderValue(params.row.organisationName) },
        {
            field: 'groupName', headerName: 'Group', flex: 0.9, sortable: false, renderCell: (params) => renderValue(params.row.groupName)
        },
        { field: 'deviceIMEI', headerName: 'IMEI', flex: 0.7, sortable: false, },
        {
            field: 'serialNumber', headerName: 'Serial number', flex: 0.7, sortable: false, renderCell: (params) => renderValue(params.row.serialNumber)
        },
        { field: 'mcuType', headerName: 'MCU Type', flex: 0.7, sortable: false, renderCell: (params) => renderValue(params.row.mcuType) },
        { field: 'autoConfigureBy', headerName: 'Configured By', flex: 0.6, sortable: false, },
        { field: 'autoConfigureAt', headerName: 'Configured At', flex: 0.9, sortable: false, renderCell: (params) => renderValue(moment(params.row.autoConfigureAt).format("DD-MM-YYYY h:mm:ss a")) },
        { field: 'bootloaderVersion', headerName: 'BL', flex: 0.4, sortable: false, },
        { field: 'desiredBootloader', headerName: 'To BL', flex: 0.4, sortable: false, },
        {
            field: 'appVersion', headerName: 'APP', flex: 0.4, sortable: false, renderCell: (params) => renderValue(params.row.appVersion)
        },
        { field: 'desiredFirmware', headerName: 'To APP', flex: 0.4, sortable: false, },
        {
            field: 'action', headerName: 'Action', flex: 0.5, sortable: false,
            renderCell: (params) => {
                const viewLog = (e) => {
                    e.stopPropagation();
                    setDeviceIMEIForLog(params.id);
                    setOpenLogPopup(true);
                    
                }
                const resetOtaCounter = (e) => {
                    e.stopPropagation();
                    setIsSingledeviceReset(true);
                    setDeviceIMEIForCounterReset(() => params.id);
                    setResetOtaCounter(true);
                }
                return <>
                    <IconButton color="success" aria-hidden="false" title="View Log" onClick={viewLog}>
                        <SyncAltIcon />
                    </IconButton>
                    {
                        params.row.counterOta >= 4
                        &&
                        <IconButton color="secondary" aria-hidden="false" title="Reset Ota Counter" onClick={resetOtaCounter}>
                        <LockOpenIcon />
                    </IconButton>
                    }
                </>;

            }
        }
    ];

    const [devices, setDevices] = React.useState([]);    
    const [selectedDevice, setSelectedDevice] = React.useState([]);
    const [alertObj, setAlertObj] = React.useState({ open: false, severity: "success", message: "" });
    const [removeDevices, setRemoveDevices] = React.useState(false);
    const [restartDevices, setRestartDevices] = React.useState(false);
    const [resetOtaCounter, setResetOtaCounter] = React.useState(false);
    const [isSingledeviceReset, setIsSingledeviceReset] = React.useState(false);
    
    // Paginatation 
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [totalRow, setTotalRow] = React.useState(Number);

    // to set log tables for single device.
    const [deviceIMEIForLog, setDeviceIMEIForLog] = React.useState();
    const [openLogPopup, setOpenLogPopup] = React.useState(false);

    const [deviceIMEIForCounterReset, setDeviceIMEIForCounterReset] = React.useState();

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setPage(0);
        setRowsPerPage(parseInt(event.target.value, 10));
    };
    const search = () => {
        getDeviceDetails();
    }
    const getDevicesData = () => {
        setPage(0);
        getDeviceDetails();
    }
    const removeFromListPopUp = () => {
        if (selectedDevice.length > 0) {
            setRemoveDevices(true)
        } else {
            setAlertObj({ open: true, severity: "error", message: "Select the device first." })
        }
    }
    const resetOtaCounterList = () => {
        if (selectedDevice.length > 0) {
            setIsSingledeviceReset(false);
            setResetOtaCounter(true);
        } else {
            setAlertObj({ open: true, severity: "error", message: "Select the device first." })
        }
    }
    
    const restartListOfDevices = () => {
        if (selectedDevice.length > 0) {
            setRestartDevices(true)
        } else {
            setAlertObj({ open: true, severity: "error", message: "Select the device first." })
        }
    }
    const renderValue = (value) => {
        return <div style={{ lineHeight: "1.2", overflowWrap: "break-word", whiteSpace: "normal", overflow: "auto", maxHeight: "inherit" }}>{value}</div>
    }

    const removeFromList = () => {
        ApiServices.removeFromConfig(selectedDevice)
            .then(response => {
                search();
                setRemoveDevices(() => false);
                if(response.status === 200){
                    setAlertObj({ open: true, severity: "success", message: "Removed From Configure." });
                }else{
                    setAlertObj({ open: true, severity: "error", message: response.data });
                }
            })
            .catch(error => {
                console.error(error);
                setAlertObj({ open: true, severity: "error", message: error.message });
            });
    }
    
    const resetCounter = () => {
        let deviceList = isSingledeviceReset ? [deviceIMEIForCounterReset] : selectedDevice
        ApiServices.resetDeviceCounter(deviceList)
            .then(response => {
                search();
                setResetOtaCounter(() => false);
                if(response.status === 200){
                    setAlertObj({ open: true, severity: "success", message: "Counter back to Zero." });
                }
            })
            .catch(error => {
                console.error(error);
                setAlertObj({ open: true, severity: "error", message: error.message });
            });
        setIsSingledeviceReset(false);
        setSelectedDevice(() => []);
    }

    const restartAllDevices = () => {
        ApiServices.restartDevices(selectedDevice)
            .then(response => {
                setRestartDevices(() => false);
                setSelectedDevice(() => []);
                search();
                if(response.status === 200){
                    setAlertObj({ open: true, severity: "success", message: "Devices restared." });
                }
            })
            .catch(error => {
                console.error(error);
                setAlertObj({ open: true, severity: "error", message: error.message });
            });
    }
    const getDeviceDetails = () => {
        const imei = dataFields["IMEI"]?.trim();

        ApiServices.searchDevices(getSearchParams(), imei)
            .then(response => {
                if (response.status === 200) {
                    setDevices(response.data);
                    setTotalRow(Number(response.headers['x-total']))
                    if (response.data) {
                        response.data.map(device => device.deviceIMEI);
                    }
                } else {
                    setDevices([]);
                }
            })
            .catch(error => {
                console.error(error);
                setAlertObj({ open: true, severity: "error", message: error.message });
                setDevices([]);
            })
    }
    const getSearchParams = () => {
        const searchParams = new URLSearchParams();        
        
        const fields = [
            { key: "bootloader", value: dataFields["Current BL"] },
            { key: "appVersion", value: dataFields["Current APP"] },
            { key: "orgName", value: dataFields["Organisation"] },
            { key: "groupName", value: dataFields["Group"] },
            { key: "toAppVersion", value: dataFields["To APP"] },
            { key: "toBootloader", value: dataFields["To BL"] },
            { key: "configuredBy", value: dataFields["Configured By"] },
            { key: "mcutype", value: dataFields["MCU Type"] },
        ];

        fields.forEach(({ key, value }) => {
            const trimmedValue = value?.trim();
            if (trimmedValue) {
                searchParams.append(key, trimmedValue);
            }
        });

        if (dataFields["Device Type"] !== 'All' && dataFields["Device Type"]) {
            searchParams.append("deviceType", dataFields["Device Type"]);
        }

        if (dataFields["Exceed Counter"]) {
            searchParams.append("counter", dataFields["Exceed Counter"]);
        }

        searchParams.append("autoOTA", true);
        searchParams.append("page", page);
        searchParams.append("size", rowsPerPage);
        searchParams.append("sort", "createdAt,desc");        
        return searchParams;
    };


    const handleClose = () => {
        setAlertObj({ open: false, severity: alertObj.severity });
    };   


    const clearSelectedDevice = () => {
        if (selectedDevice.length > 0) {
            setSelectedDevice(() => []);
            setAlertObj({ open: true, severity: "success", message: "Cleared all selected devices." })
        }
    }
    const [availableFields, setAvailableFields] = useState([
        "Organisation",
        "Group",
        "IMEI",
        "Configured By",
        "MCU Type",
        "Current BL",
        "Current APP",
        "To APP",
        "To BL",
        "Device Type",
        "Exceed Counter",
    ]);
    const [selectedField, setSelectedField] = useState("");
    const [fieldValues, setFieldValues] = useState({});
    const [chipData, setChipData] = useState([]);

    const [dataFields, setDataFields] = useState(() =>
        availableFields.reduce((acc, field) => {
            acc[field] = "";
            return acc;
        }, {})
    );


    const mcuTypes = [
        "",
        "STM32F103_512",
        "STM32L451_512",
        "GD32F303_512",
        "STM32F103_256",
        "STM32F103_128",
    ];

    const handleAddChip = () => {        

        if (selectedField && fieldValues[selectedField] !== undefined) {

            setChipData((prevChipData) => [
                ...prevChipData,
                { field: selectedField, value: fieldValues[selectedField] }
            ]);

            setFieldValues((prevFieldValues) => ({ ...prevFieldValues, [selectedField]: "" }));

            setAvailableFields((prevAvailableFields) =>
                prevAvailableFields.filter((field) => field !== selectedField)
            );

            setSelectedField("");

            getDevicesData();
        }
    };
    const [fieldToRemove, setFieldToRemove] = useState(false);    

    const handleRemoveChip = (field) => {                
        setDataFields((prevDataFields) => {
            const updatedDataFields = { ...prevDataFields };
            updatedDataFields[field] = ""; 
            return updatedDataFields;
        });

        setAvailableFields((prevFields) => [...prevFields, field]);

        const updatedChipData = chipData.filter((chip) => chip.field !== field);
        setChipData(updatedChipData);
        
        setFieldValues((prevValues) => {
            const updatedValues = { ...prevValues };
            delete updatedValues[field];
            return updatedValues;
        });    

        setFieldToRemove(old => !old);        
    };


    const handleInputChange = (field, value) => {
        setFieldValues((prev) => ({ ...prev, [field]: value }));

        setDataFields((prevDataFields) => {
            if (field in prevDataFields) {
                return { ...prevDataFields, [field]: value };
            }
            return prevDataFields;
        });
    };

    const handleCheckboxChange = (field, checked) => {
        setFieldValues((prev) => ({ ...prev, [field]: checked }));

        setDataFields((prevDataFields) => {
            if (field in prevDataFields) {
                return { ...prevDataFields, [field]: checked };
            }
            return prevDataFields;
        });
    };

    const handleCopyToClipboard = (imei) => {
        navigator.clipboard.writeText(imei).then(() => {
            alert(`IMEI copied to clipboard.`);
        });
    };
    const handleClearAllChips = () => {
        setDataFields((prevDataFields) => {
            const clearedFields = Object.keys(prevDataFields).reduce((acc, key) => {
                acc[key] = "";
                return acc;
            }, {});
            return clearedFields;
        });

        setChipData(() => []);
        setAvailableFields([
            "Organisation",
            "Group",
            "IMEI",
            "Configured By",
            "MCU Type",
            "Current BL",
            "Current APP",
            "To APP",
            "To BL",
            "Device Type",
            "Exceed Counter",
        ]);    

        setFieldToRemove(old => !old);        
    };
    const [enableSelectAll,setEnableSelectAll] = useState(false);  
    const [selectAll, setSelectAll] = React.useState(false);
    const selectAllDevices = (e) => {               
            if(e.target.checked){
                setSelectAll(() => true);
                const imei = dataFields["IMEI"]?.trim();                
                ApiServices.getDevicesIMEIs(getSearchParams(), imei)
                .then(response => {                                             
                    if (response.status === 200) {                   
                        setSelectedDevice(() => response.data);
                    }
                })
                .catch(error => {
                    console.error(error);
                    setAlertObj({ open: true, severity: "error", message: error.message });
                });
            }else{
                clearSelectedDevice();
                setSelectAll(()=> false);
            }        
        }

    useEffect(() => {
        search();
        setSelectedDevice(() => []);
        setSelectAll(()=> false);
    }, [page, rowsPerPage]);


    useEffect(() => {        
        search();    
        setSelectedDevice(() => []);
        setSelectAll(()=> false);
    }, [fieldToRemove]);

    useEffect(()=>{                
        if(availableFields.length < 11){            
            setEnableSelectAll(()=>true);
        }else{
            setEnableSelectAll(()=>false);
        }
    },[availableFields]);


    return (
        <div style={{ height: 600, width: '100%' }}>
            <Box sx={{
                width: "100%"
            }}>
                <Box sx={{ width: "70%", float: "left" }}>
                    {availableFields.length > 0 && (
                        <>
                            <Select
                                value={selectedField}
                                onChange={(e) => setSelectedField(e.target.value)}
                                displayEmpty
                                variant='standard'
                                style={{ width: 170, marginTop: 5,marginRight:10 }}
                            >
                                <MenuItem value="" disabled>
                                    Search Field
                                </MenuItem>
                                {availableFields.map((field) => (
                                    <MenuItem key={field} value={field}>
                                        {field}
                                    </MenuItem>
                                ))}
                            </Select>

                            {selectedField && (
                                <>
                                    {selectedField === "MCU Type" && (
                                        <Select
                                            value={fieldValues["MCU Type"] || ""}
                                            onChange={(e) => handleInputChange("MCU Type", e.target.value)}
                                            sx={{ width: 150, marginRight: 2 }}
                                        >
                                            <MenuItem value="">Select MCU Type</MenuItem>
                                            {mcuTypes.map((type, index) => (
                                                <MenuItem key={index} value={type}>
                                                    {type}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    )}

                                    {selectedField === "Device Type" && (
                                        <Select
                                            value={fieldValues["Device Type"] || ""}
                                            onChange={(e) => handleInputChange("Device Type", e.target.value)}
                                            sx={{ width: 150, marginRight: 2 }}
                                        >
                                            <MenuItem value="All">All</MenuItem>
                                            <MenuItem value="iot1">IOT V1</MenuItem>
                                            <MenuItem value="iot2">IOT V2</MenuItem>
                                            <MenuItem value="iot3">IOT V3</MenuItem>
                                        </Select>
                                    )}

                                    {selectedField === "Exceed Counter" && (
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={fieldValues["Exceed Counter"] || false}
                                                    onChange={(e) => handleCheckboxChange("Exceed Counter", e.target.checked)}
                                                />
                                            }
                                            label="Exceed Counter"
                                            sx={{ marginRight: 2 }}
                                        />
                                    )}

                                    {selectedField &&
                                        !["MCU Type", "Device Type", "Exceed Counter"].includes(selectedField) && (
                                            <TextField
                                                value={fieldValues[selectedField] || ""}
                                                onChange={(e) => handleInputChange(selectedField, e.target.value)}
                                                placeholder={`Enter ${selectedField}`}
                                                sx={{ width: 170, marginRight: 1 }}
                                                size="small"
                                            />
                                        )}
                                    <Button                                        
                                        variant="contained"
                                        color="primary"
                                        onClick={() => handleAddChip()}
                                        disabled={
                                            selectedField === "Exceed Counter"
                                                ? false
                                                : fieldValues[selectedField] === undefined ||
                                                fieldValues[selectedField] === ""
                                        }
                                    >
                                        <Search />
                                    </Button>
                                </>
                            )}
                        </>
                    )}
                    {chipData.length > 0 && (
                        <Box
                            sx={{
                                marginTop: 3,
                                textAlign: "left",
                                padding: "10px",
                                border: (theme) => `1px solid ${theme.palette.divider}`,
                                borderRadius: "5px",
                                position: "relative",
                                backgroundColor: "background.paper",
                            }}
                        >
                            <Box
                                variant="text"
                                color="secondary"
                                onClick={() => handleClearAllChips()}
                                sx={{
                                    position: "absolute",
                                    top: "-8px",
                                    right: "-8px",
                                    padding: "1",
                                    borderRadius: "40%",
                                    border: (theme) => `1px solid ${theme.palette.divider}`,
                                    backgroundColor: "background.paper",
                                    color: 'error.main',
                                }}
                            >
                                <Delete fontSize="small" sx={{ color: 'red' }} />
                            </Box>
                            <Box
                                sx={{
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    position: "absolute",
                                    top: "-12px",
                                    left: "10px",
                                    backgroundColor: "background.paper",
                                    color: "text.secondary",
                                    padding: "0 5px",
                                    borderRadius: "50%",
                                }}
                            >
                                Applied Filter
                            </Box>
                            <Stack
                                direction="row"
                                spacing={1}
                                sx={{ marginTop: 2, flexWrap: "wrap" }}
                            >
                                {chipData.map((chip, index) => (
                                    <Chip
                                        key={index}
                                        label={
                                            chip.field === "IMEI" && chip.value.length > 48
                                                ? "IMEI"
                                                :
                                                chip.field === "Exceed Counter" && chip.value
                                                    ? "Exceed"
                                                    :
                                                    chip.field === "Current BL" && chip.value
                                                        ? "BL :" + chip.value
                                                        :
                                                        chip.field === "Current APP" && chip.value
                                                            ? "APP :" + chip.value
                                                            :
                                                            chip.field === "To APP" && chip.value
                                                                ? "To APP :" + chip.value
                                                                :
                                                                chip.field === "To BL" && chip.value
                                                                    ? "To BL :" + chip.value
                                                                    :
                                                                    chip.value
                                        }
                                        onDelete={() => handleRemoveChip(chip.field)}
                                        deleteIcon={<Close />}
                                        sx={{ margin: "4px", fontSize: "12px" }}
                                        {...(chip.field === "IMEI" && {
                                            onClick: () => handleCopyToClipboard(chip.value),
                                            clickable: true,
                                            icon: <ContentCopy />,
                                        })}
                                    />
                                ))}
                            </Stack>
                        </Box>
                    )}
                </Box>
                <Box
                    component="span"
                    display="inline-block"
                    textAlign="right"
                    sx={{
                        '& > :not(style)': { m: 1 },
                        width: "30%",
                        float: "right"
                    }}>
                    <Button variant="contained" title="Reset Ota counter" onClick={resetOtaCounterList} ><LockOpenIcon /> </Button>
                    <Button variant="contained" color="secondary" title="Remove from list" onClick={removeFromListPopUp}><DeleteForeverIcon /> </Button>
                    <Button variant="contained" style={{ backgroundColor: "#00C9A7" }} title="Restart" onClick={restartListOfDevices}><RestartAltIcon /> </Button>
                    <Button variant="contained" color="primary" title="Clear Selection" onClick={clearSelectedDevice}> <ClearAll /></Button>
                </Box>
            </Box>
            <Box sx={{width:"100%"}}>
                <Box sx={{width:"100%",float:"right"}}>                    
                    { 
                    enableSelectAll && 
                    <FormGroup style={{width:"30%",float:"left",marginLeft:23}}>                                    
                        <FormControlLabel  control={<Checkbox checked={selectAll} onClick={selectAllDevices}/>} label="Select All" />                     
                    </FormGroup>  
                    }                                        
                    <TablePagination
                    sx={{width:"50%",float:"right"}}
                    component="div"
                    count={totalRow}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[10, 20, 50, 100, 500, 1000]}
                />
                </Box>
                <DataGrid
                    style={{width:"100%"}}
                    getRowId={(row) => row.deviceIMEI}
                    rows={devices}
                    columns={columns}
                    disableSelectionOnClick
                    disableColumnMenu
                    autoHeight={true}
                    hideFooter={true}
                />
                <TablePagination
                    width="100%"
                    component="div"
                    count={totalRow}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[10, 20, 50, 100, 500, 1000]}
                />
            </Box>
            <Popup
                title={'Log for imei : ' + deviceIMEIForLog}
                openPopup={openLogPopup}
                setOpenPopup={setOpenLogPopup}
            >
                <DeviceLog imei={deviceIMEIForLog} />
            </Popup>
            <Snackbar
                style={{ top: '30%' }}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                autoHideDuration={2000}
                open={alertObj.open}
                onClose={handleClose}
            >
                <Alert severity={alertObj.severity} sx={{ width: '100%' }}>
                    {alertObj.message}
                </Alert>
            </Snackbar>
            <Dialog
                open={resetOtaCounter}
                onClose={() => setResetOtaCounter(() => false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle style={{ color: 'red' }} id="alert-dialog-title">
                    {"Warning"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Device counter will reset.
                        Are you sure?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setResetOtaCounter(() => false)}>Cancel</Button>
                    <Button onClick={resetCounter} autoFocus>
                        Reset
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={removeDevices}
                onClose={() => setRemoveDevices(() => false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle style={{ color: 'red' }} id="alert-dialog-title">
                    {"Warning"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Selected device will be removed from the configuration.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setRemoveDevices(() => false)}>Disagree</Button>
                    <Button onClick={removeFromList} autoFocus>
                        Agree
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={restartDevices}
                onClose={() => setRestartDevices(() => false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle style={{ color: 'red' }} id="alert-dialog-title">
                    {"Warning"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <span><b>{selectedDevice.length} Devices Set to Restart </b></span>
                        <br></br>
                        <br></br>
                        <TextareaAutosize
                            style={{ width: 550 }}
                            disabled={true}
                            aria-label="empty textarea"
                            placeholder="Empty"
                            minRows={8}
                            maxRows={8}
                            value={String([...selectedDevice])}
                        />
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setRestartDevices(() => false)}>Disagree</Button>
                    <Button onClick={restartAllDevices} autoFocus>
                        Agree
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default AutomationTable

